<div class="stepper-container">
    <div class="stepper-inner-container">
        <ul class="stepper">
            <ng-container *ngFor="let tab of tabs; let i = index">
                <div *ngIf="i" class="line"></div>
                <li [class.active]="i === tabIndex">
                    {{ tab.title }}
                </li>
            </ng-container>
        </ul>
    </div>
</div>

<ng-content></ng-content>
<div class="d-flex mt-s5">
    <button type="button" class="secondary" (click)="previous.emit()" *ngIf="tabIndex > 0">
        <span class="material-symbols-rounded leading">arrow_left_alt</span>
        {{ 'BUTTONS.PREVIOUS' | translate }}
    </button>
    <div class="button-right-container">
        <button type="button" class="secondary me-s2" (click)="cancelClick.emit()">
            {{ 'BUTTONS.CANCEL' | translate }}
        </button>
        <button *ngIf="tabIndex < lastTabIndex" type="button " class="primary" (click)="next.emit()">
            {{ 'BUTTONS.NEXT' | translate }}
            <span class="material-symbols-rounded trailing">arrow_right_alt</span>
        </button>
        <button
            *ngIf="tabIndex >= lastTabIndex"
            [class.loading]="loading"
            [disabled]="loading"
            type="button"
            class="primary no-focus"
            appSaveButtonFormValidity
            [form]="form"
            (click)="save.emit()"
        >
            {{ saveButtonLabelLanguageKey | translate }}
        </button>
    </div>
</div>
